var _circle, _circle2, _circle3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTriToneOverlappingCircles = function SvgTriToneOverlappingCircles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 31,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22.406,
    cy: 21.954,
    r: 9.045,
    fill: "#5B3552",
    transform: "rotate(-90 22.406 21.954)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 9.594,
    cy: 21.954,
    r: 9.045,
    fill: "#FF2E5B",
    transform: "rotate(-90 9.594 21.954)"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.097,
    cy: 9.044,
    r: 9.045,
    fill: "#FFE1E7",
    transform: "rotate(-90 16.097 9.044)"
  })));
};
export { SvgTriToneOverlappingCircles as ReactComponent };
export default __webpack_public_path__ + "images/tri-tone-overlapping-circles.svg";